<template>
  <div id="dashboard" class="ticket-ok-page">
    <div id="fondo" class="ticket-ok-bg">
      <div class="container ticket-ok-container">
        <div class="row justify-content-center mt-5">
          <div class="col-12 col-md-8 col-lg-6 mt-5">
            <div class="ticket-ok-card mt-5">
              <!-- Título -->
              <p class="fXG blanco text-center p-5">
              <img src="../assets/imgs/dominos/registra-tu-ticket-y suma-goles.png" class="w-100 tituloseccion" alt="Domino's Pizza">
            </p>

              <!-- Mensaje principal -->
              <div
                class="ticket-ok-message"
                data-aos="fade-up"
                data-aos-delay="160"
              >
                Tu ticket fue enviado correctamente.
              </div>

              <!-- Check -->
              <div
                class="ticket-ok-check-wrap"
                data-aos="zoom-in"
                data-aos-delay="220"
              >
                <img
                  src="../assets/imgs/dominos/check-azul.png"
                  alt="Ticket enviado correctamente"
                  class="ticket-ok-check"
                />
              </div>

              <!-- Texto secundario -->
              <div
                class="ticket-ok-subtitle"
                data-aos="fade-up"
                data-aos-delay="280"
              >
                Estamos revisando tu ticket
              </div>

              <div
                class="ticket-ok-description"
                data-aos="fade-up"
                data-aos-delay="320"
              >
                En breve te confirmaremos si es válido para acumular puntos.
              </div>

              <!-- Botón -->
              <div
                class="ticket-ok-actions"
                data-aos="fade-up"
                data-aos-delay="380"
              >
                <router-link to="/dashboard" class="ticket-ok-btn">
                  REGISTRAR NUEVO TICKET
                </router-link>
              </div>

              <!--
              <div class="ticket-ok-extra-link">
                <router-link to="/mis-participaciones" class="ticket-ok-link">
                  Ver mis puntos acumulados
                </router-link>
              </div>
              -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <Footer></Footer>
  </div>
</template>

<script>
// import { commentsCollection } from "@/firebase";
import { mapState } from "vuex";
import AOS from "aos";
// import moment from "moment";
// import swal from "sweetalert2";
import Footer from "@/components/Footer";

export default {
  components: {
    Footer,
  },
  data() {
    return {
      // file: null,
      // overlay_transaccion: false,
      // overlay_sucursal: false,
    };
  },
  computed: {
    ...mapState(["userProfile", "posts"]),
  },
  mounted() {
    AOS.init({
      offset: -120,
      delay: 0,
      duration: 800,
      easing: "ease-in-out",
      once: false,
      mirror: false,
      anchorPlacement: "top-bottom",
    });
  },
  methods: {
    // fileSelected() {},
    // async tomarTrivia() {},
    // uploadVeryfi() {},
    // toggleSucursal() {
    //   this.overlay_sucursal = !this.overlay_sucursal;
    // },
    // toggleTransaccion() {
    //   this.overlay_transaccion = !this.overlay_transaccion;
    // },
  },
  filters: {
    // formatDate(val) {
    //   if (!val) return "-";
    //   let date = val.toDate();
    //   return moment(date).fromNow();
    // },
    // trimLength(val) {
    //   if (val.length < 200) return val;
    //   return `${val.substring(0, 200)}...`;
    // },
  },
};
</script>

<style lang="scss" scoped>
.ticket-ok-page {
  min-height: 100vh;
  background: #0d95df;
}

.ticket-ok-bg {
  min-height: calc(100vh - 120px);
  background: #0d95df;
  padding: 22px 0 50px;
}

.ticket-ok-container {
  max-width: 1500px;
}

.ticket-ok-card {
  text-align: center;
  color: #fff;
  padding: 10px 12px 40px;
}

.ticket-ok-title-box {
  display: inline-block;
  border: 1px solid rgba(255, 255, 255, 0.7);
  padding: 10px 18px;
  margin-bottom: 42px;
}

.ticket-ok-title {
  margin: 0;
  font-size: 2.3rem;
  line-height: 0.98;
  font-weight: 900;
  color: #ffffff;
}

.ticket-ok-message {
  font-size: 2rem;
  line-height: 1.05;
  font-weight: 800;
  max-width: 520px;
  margin: 0 auto 28px;
  color: #ffffff;
}

.ticket-ok-check-wrap {
  margin: 10px 0 26px;
}

.ticket-ok-check {
  width: 180px;
  max-width: 70%;
  height: auto;
  display: inline-block;
}

.ticket-ok-subtitle {
  font-size: 1.2rem;
  font-weight: 800;
  color: #ffffff;
  margin-bottom: 14px;
}

.ticket-ok-description {
  font-size: 1.35rem;
  line-height: 1.15;
  max-width: 470px;
  margin: 0 auto;
  color: #ffffff;
}

.ticket-ok-actions {
  margin-top: 42px;
}

.ticket-ok-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 62px;
  width: 100%;
  max-width: 420px;
  background: #f23a16;
  color: #fff;
  text-decoration: none;
  border-radius: 10px;
  font-size: 1.45rem;
  font-weight: 900;
  padding: 12px 24px;
  transition: 0.2s ease;
}

.ticket-ok-btn:hover {
  color: #fff;
  text-decoration: none;
  opacity: 0.96;
  transform: translateY(-1px);
}

.ticket-ok-extra-link {
  margin-top: 20px;
}

.ticket-ok-link {
  color: #fff;
  text-decoration: underline;
  font-weight: 700;
}

@media (max-width: 767px) {
  .ticket-ok-bg {
    padding: 14px 0 35px;
  }

  .ticket-ok-card {
    padding: 4px 8px 30px;
  }

  .ticket-ok-title-box {
    padding: 8px 14px;
    margin-bottom: 34px;
  }

  .ticket-ok-title {
    font-size: 1.55rem;
    line-height: 0.98;
  }

  .ticket-ok-message {
    font-size: 1rem;
    line-height: 1.05;
    max-width: 250px;
    margin-bottom: 22px;
  }

  .ticket-ok-check {
    width: 140px;
    max-width: 62%;
  }

  .ticket-ok-subtitle {
    font-size: 0.95rem;
    margin-bottom: 12px;
  }

  .ticket-ok-description {
    font-size: 0.95rem;
    line-height: 1.15;
    max-width: 250px;
  }

  .ticket-ok-actions {
    margin-top: 34px;
  }

  .ticket-ok-btn {
    max-width: 250px;
    min-height: 44px;
    font-size: 0.95rem;
    border-radius: 8px;
    padding: 10px 14px;
  }
}
</style>